import { useCookiesPerformanceAccepted } from '../context/CookiesAcceptance';
import { trackCustomEvent as gaTrackCustomEvent } from 'gatsby-plugin-google-analytics';
import { useDebug } from '../context/Debug';

/**
 * !INTERNAL
 * DON'T EXPORT THIS FOR EXTERNAL REFERENCES
 * COOKIE ACCEPTANCE FROM USER NEED TO BE VERIFIED BEFORE USE!
 */
function trackCustomEvent(args, debug = false) {
  if (debug) console.log('Tracking custom event w/args:', args);
  gaTrackCustomEvent(args);
}

function notTrackingCustomEvent(args, debug = false) {
  if (debug) console.log('NOT tracking custom event w/args:', args);
  return void null;
}

export function useTrackCustomEvent() {
  let debug = useDebug();
  let accepted = useCookiesPerformanceAccepted();
  let trackFn = accepted ? args => trackCustomEvent(args, debug) : args => notTrackingCustomEvent(args, debug);
  return trackFn;
}
